import { useEffect, useState } from 'react';
import Header from '../Header/Header';
import './SignInvoice.scss';
import axios from 'axios';
import { toast } from 'react-toastify';
import Loader from '../Loader/Loader';
import Grid, { GridColumn, GridHeader, GridRow } from '../Grid/Grid';
import { Row, Card, Tabs, Tab, Col } from 'react-bootstrap';
import phoneIcon from '../assets/images/phone.svg';
import mailIcon from '../assets/images/mail.svg';
import HelperService from '../utility/HelperService';
import { Globe } from 'react-bootstrap-icons';
import stopIcon from "../../src/assets/images/stop.svg";
import EquipmentPreviewBlade from '../InvoiceDetail/EquipmentPreviewBlade';
import SignatureCanvas from '../SignatureCanvas/SignatureCanvas';
import { Button } from '../Button/Button';
import invoiceImage from '../assets/images/OnInvoice.jpg';
import InvoiceDetailHeader from '../InvoiceDetail/InvoiceDetailHeader';
import Footer from '../Footer/Footer';
import WebService from '../utility/WebService';

const headers: GridHeader[] = [
    {
        title: "Technician",
        class: 'text-center',
    },
    {
        title: "Service Date",
        class: 'text-center',
    },
    {
        title: "Arrive & Completion ",
        class: 'text-center'
    },
];

const EquipHeaders: GridHeader[] = [
    {
        title: "",
        class: 'text-center',
    },
    {
        title: "Manufacturer",
        class: 'text-center',
    },
    {
        title: "Model",
        class: 'text-center'
    },
    {
        title: "Description",
        class: 'text-center'
    },
    {
        title: "Serial #",
        class: 'text-center'
    },
    {
        title: "Location",
        class: 'text-center'
    },
    {
        title: "System",
        class: 'text-center'
    },
    {
        title: "Unit",
        class: 'text-center'
    },
]

const SignInvoice = () => {
    const [rows, setRows] = useState<GridRow[]>([]);
    const [equipRows, setEquipRows] = useState<GridRow[]>([]);
    const [isLoading, setLoading] = useState(false);
    const [invoiceData, setInvoiceData] = useState<any>({});
    const [companyCode, setCompanyCode] = useState<any>();
    const [invoiceNum, setInvoiceNum] = useState<any>();
    const [isShowInvoice, setIsShowInvoice] = useState(false);
    const [showModal, setShowModal] = useState(false)
    const [selectedData, setSelectedData] = useState<any>();
    const [currentSign, setCurrentSign] = useState<any>();
    const [clearSign, setClearSign] = useState<any>();
    const [tenantUrl, setTenantUrl] = useState<any>('');
    const [id, setId] = useState<any>()
    const [techName, setTechName] = useState<any>('')
    const [otherData, setOtherData] = useState<any>()
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const value = urlParams.get('token')


    useEffect(() => {
        if (value) {
            setId(value)
            getAccessToken()
        } else {
            setId('')
        }
    }, [])

    const getAccessToken = () => {
        localStorage.clear();
        // 1297
        setLoading(true)
        axios.get(`${WebService.getUrl()}admin/Auth/verify-sawinToken?id=${value}`)
            .then((res: any) => {
                setLoading(false)
                if (res.data.status == 'Error') {
                    toast.error(res.data.message)
                    setIsShowInvoice(false)
                }
                if (res.data.accessToken) {
                    setOtherData(res.data)
                    getInvoiceData(res.data.accessToken, res.data.companyCode, res.data.invoiceNumber, res.data.tenantUrl)
                    setTenantUrl(res.data.tenantUrl)
                    setInvoiceNum(res.data.invoiceNumber)
                    setCompanyCode(res.data.companyCode)
                    localStorage.setItem('token', res.data.accessToken)
                    localStorage.setItem('tenant_url', res.data.tenantUrl)
                }
            })
            .catch((e) => {
                setId('')
                setIsShowInvoice(false)
                setLoading(false);
            })
    };

    const getInvoiceData = (token: string, code: string, invoice: string, url: string) => {
        // 1297;1453
        const headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
        };
        setLoading(true)
        axios.get(`${url}/api/Invoice/customerInvoiceInfo?CompanyCode=${code}&InvoiceNumber=${invoice}`, {
            headers: headers,
        })
            .then((res: any) => {
                setLoading(false)
                if (res.data) {
                    setIsShowInvoice(true)
                    setTechName(res.data.data.callInfo.signedBy)
                    res.data.data.callInfo.invoiceNum = invoice;
                    if (res.data.data.techList) {
                        let rows: GridRow[] = [];
                        for (var i in res.data.data.techList) {
                            let columns: GridColumn[] = [];
                            columns.push({ value: res.data.data.techList[i].techName });
                            columns.push({ value: res.data.data.techList[i].servDate && HelperService.getFormatedDate(res.data.data.techList[i].servDate) });
                            columns.push({ value: res.data.data.techList[i].techtime });
                            rows.push({ data: columns });
                        }
                        setRows(rows);
                    }
                    if (res.data.data.equipments) {
                        let rows: GridRow[] = [];
                        for (var i in res.data.data.equipments) {
                            let columns: GridColumn[] = [];
                            columns.push({ value: renderImage(res.data.data.equipments[i]) });
                            columns.push({ value: res.data.data.equipments[i].eqpManufacturer ? res.data.data.equipments[i].eqpManufacturer : '-' });
                            columns.push({ value: res.data.data.equipments[i].modelNum ? res.data.data.equipments[i].modelNum : '-' });
                            columns.push({ value: res.data.data.equipments[i].eqpDescription ? res.data.data.equipments[i].eqpDescription : '-' });
                            columns.push({ value: res.data.data.equipments[i].serialNum ? res.data.data.equipments[i].serialNum : '-' });
                            columns.push({ value: res.data.data.equipments[i].eqpLocation ? res.data.data.equipments[i].eqpLocation : '-' });
                            columns.push({ value: res.data.data.equipments[i].eqpSystem ? res.data.data.equipments[i].eqpSystem : '-' });
                            columns.push({ value: res.data.data.equipments[i].unitNum ? res.data.data.equipments[i].unitNum : '-' });
                            rows.push({ data: columns, type: 'A', backgroundColor: res.data.data.equipments[i].bg, textColor: res.data.data.equipments[i].tc });


                            let columns1: GridColumn[] = [];
                            columns1.push({ value: res.data.data.equipments[i].eqpDescription ? res.data.data.equipments[i].eqpDescription : '-' });
                            rows.push({ data: columns1, type: 'B', backgroundColor: res.data.data.equipments[i].bg, textColor: res.data.data.equipments[i].tc });
                        }
                        setEquipRows(rows);
                    }
                    setInvoiceData(res.data.data);
                }
            })
            .catch((e) => {
                setLoading(false);
            });
    };

    const renderImage = (data: any) => {
        return (
            <img src={data.eqpImageURL} height={40} width={40} onClick={() => {
                setSelectedData(data.eqpImageURL)
                setShowModal(true)
            }} />
        )
    }

    const onCloseModal = () => {
        setShowModal(false)
    }

    const onSign = (e: any) => {
        // console.log(e);
        setCurrentSign(e)
    }

    const onClearSign = () => {
        setCurrentSign(null)
        setClearSign(new Date().getTime())
    }

    const onSubmit = () => {
        if (techName == '') {
            toast.error('Please enter name.')
        } else if (!currentSign) {
            toast.error('Please sign.')
        } else {
            const headers = {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem('token'),
            };
            setLoading(true)
            axios.post(`${tenantUrl}/api/Invoice/updateSignature`, {
                platform: 'WEB',
                serviceMasterNum: invoiceData.location.smNum,
                tipAmount: 0,
                signature: {
                    CompanyCode: companyCode,
                    invoiceNum: invoiceNum,
                    signImage: currentSign.replace("data:image/png;base64,", ''),
                    signedBy: techName,
                    techNum: '',
                    woNum: invoiceData.callInfo.woNum
                }
            }, {
                headers: headers,
            },)
                .then((res) => {
                    toast.success('Invoice Signed Successfully')
                    setLoading(false)
                })
                .catch((e) => {
                    toast.error('Error')
                    setLoading(false)
                })
        }
    }

    return (
        <>
            <EquipmentPreviewBlade
                isShow={showModal}
                isClose={onCloseModal}
                data={selectedData}
            />
            <Loader show={isLoading} />
            <Header isSignHeader={true} />
            {
                isShowInvoice &&
                <div className='p-2'>
                    <Card className="content-card card-shadow p-0 ">
                        <Card.Body className="py-2 text-dark">
                            <Row className="mb-3 pt-1">
                                {
                                    otherData?.genericLogoUrl &&
                                    <Col md={3}>
                                        <img src={otherData?.genericLogoUrl} width={200} height={130} />
                                    </Col>
                                }
                                <Col md={3}>
                                    <div className="mb-0 font-w-medium font-15">Company Info</div>
                                    {
                                        invoiceData?.companyInfo?.companyAddr1 && <div className="address-text">{invoiceData?.companyInfo?.companyAddr1}</div>
                                    }
                                    {
                                        invoiceData?.companyInfo?.companyAddr2 && <div className="address-text">{invoiceData?.companyInfo?.companyAddr2}</div>
                                    }
                                    {
                                        invoiceData?.companyInfo?.companyCity && <div className="address-text">{invoiceData?.companyInfo?.companyCity} {invoiceData?.companyInfo?.companyState && ', ' + invoiceData?.companyInfo?.companyState} {invoiceData?.companyInfo?.companyZip && ", " + invoiceData?.companyInfo?.companyZip}</div>
                                    }
                                    {
                                        invoiceData?.companyInfo?.compPhone && <div className="address-text">
                                            <img src={phoneIcon} className="me-2" />
                                            {HelperService.getFormattedContact(invoiceData?.companyInfo?.compPhone)}</div>
                                    }
                                    {
                                        invoiceData?.companyInfo?.compEmail && <div className="address-text">
                                            <img src={mailIcon} className="me-2" />
                                            {invoiceData?.companyInfo?.compEmail}</div>
                                    }
                                    {
                                        invoiceData?.companyInfo?.compWebAddress && <div className="address-text">
                                            <Globe className="me-2" />
                                            {invoiceData?.companyInfo?.compWebAddress}</div>
                                    }
                                </Col>
                                <Col md={3}>
                                    <div className="mb-0 font-w-medium font-15">Bill To
                                        {invoiceData?.billTo?.acctOnCreditHold == true && <img src={stopIcon} className="ms-2 mb-1" />}</div>
                                    {
                                        invoiceData?.billTo?.custAddress1 && <div className="address-text">{invoiceData?.billTo?.custAddress1}</div>
                                    }
                                    {
                                        invoiceData?.billTo?.custAddress2 && <div className="address-text">{invoiceData?.billTo?.custAddress2}</div>
                                    }
                                    {
                                        invoiceData?.billTo?.custCity && <div className="address-text">{invoiceData?.billTo?.custCity} {invoiceData?.billTo?.custState && ', ' + invoiceData?.billTo?.custState} {invoiceData?.billTo?.custZip && ", " + invoiceData?.billTo?.custZip}</div>
                                    }
                                    {
                                        invoiceData?.billTo?.customerPhone && <div className="address-text">
                                            <img src={phoneIcon} className="me-2" />
                                            {HelperService.getFormattedContact(invoiceData?.billTo?.customerPhone)}</div>
                                    }
                                    {
                                        invoiceData?.billTo?.custEmail && <div className="address-text">
                                            <img src={mailIcon} className="me-2" />
                                            {invoiceData?.billTo?.custEmail}</div>
                                    }
                                </Col>
                                <Col md={3}>
                                    <div className="mb-0 font-w-medium font-15">Location</div>
                                    {
                                        invoiceData?.location?.address1 && <div className="address-text">{invoiceData?.location?.address1}</div>
                                    }
                                    {
                                        invoiceData?.location?.address2 && <div className="address-text">{invoiceData?.location?.address2}</div>
                                    }
                                    {
                                        invoiceData?.location?.city && <div className="address-text">{invoiceData?.location?.city} {invoiceData?.location?.state && ', ' + invoiceData?.location?.state} {invoiceData?.location?.zip && ", " + invoiceData?.location?.zip}</div>
                                    }
                                    {
                                        invoiceData?.location?.smPhone && <div className="address-text">
                                            <img src={phoneIcon} className="me-2" />
                                            {HelperService.getFormattedContact(invoiceData?.location?.smPhone)}</div>
                                    }
                                    {
                                        invoiceData?.location?.defaultEMail && <div className="address-text">
                                            <img src={mailIcon} className="me-2" />
                                            {invoiceData?.location?.defaultEMail}</div>
                                    }
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <InvoiceDetailHeader InvoiceData={invoiceData} showLoader={isLoading} type='SIGN_INVOICE' />
                    <Card className="content-card card-shadow p-0 mt-1">
                        <div className="mb-0 font-w-medium font-15 ms-3 mt-2">Technicians</div>
                        <Grid
                            headers={headers}
                            rows={rows} />
                    </Card>
                    <Card className="content-card card-shadow p-0 mt-1">
                        <div className="mb-0 font-w-medium font-15 ms-3 mt-2">Equipment</div>
                        <Grid
                            headers={EquipHeaders}
                            rows={equipRows} />
                    </Card>
                    <Card className="content-card card-shadow p-0 mt-1">
                        <div className="mb-0 font-w-medium font-15 ms-3 mt-2">Work Description</div>
                        {
                            invoiceData?.callInfo?.workDescription ?
                                <div className='ms-3 font-14 mb-4 mt-2' dangerouslySetInnerHTML={{ __html: invoiceData?.callInfo?.workDescription }} />
                                :
                                <div className='ms-3 font-14 mb-4 mt-2'>No Work Description</div>
                        }
                    </Card>
                    <Card className="content-card card-shadow p-4 mt-1">
                        {
                            invoiceData?.callInfo?.invoiceSignature ?
                                <div className='text-end'>
                                    {invoiceData?.callInfo?.invoiceSignature && <img src={`data:image/png;base64,${invoiceData?.callInfo?.invoiceSignature}`} style={{ height: 150, width: 200 }} />}
                                    <div style={{ marginRight: 50, }}>
                                        {invoiceData?.callInfo?.signedBy && <div>{invoiceData?.callInfo?.signedBy}</div>}
                                        {invoiceData?.callInfo?.signedOn && <div>{HelperService.getFormatedDateAndTime(invoiceData?.callInfo?.signedOn)}</div>}
                                    </div>
                                </div>
                                :
                                <>
                                    <div className='sign-invoice-panel'>
                                        <div className='sign-invoice-fields'>
                                            <div className='sign-invoice-name'>
                                                <label className='font-w-medium font-13'>Name</label>
                                                <input className='form-control' value={techName} onChange={(e) => setTechName(e.target.value)} />
                                            </div>
                                            <div className='sign-invoice-actions'>
                                                <Button label='Clear' b_type='CANCEL' onClick={() => onClearSign()} />
                                                <Button label='Save' onClick={() => onSubmit()} />
                                            </div>
                                        </div>
                                        <div className='sign-invoice-canvas'>
                                            <SignatureCanvas signature={onSign} isClear={clearSign} previousSignature={'data:image/png;base64,' + invoiceData?.callInfo?.invoiceSignature} />
                                        </div>
                                    </div>
                                </>
                        }
                    </Card>
                </div>
            }
            {
                isShowInvoice == false && id == '' &&
                <div className="no-invoice-view">
                    <img src={invoiceImage} height={200} width={200} />
                    <span className="no-invoice">No Invoice Found!</span>
                </div>
            }
            <Footer data={otherData?.genericFooter} />
        </>
    )
}

export default SignInvoice;